module.exports = __webpack_public_path__ + "static/media/moon_daytime.49f32a56.gif";